import React from "react";

import { Button, Typography } from "@mui/material";

// import testKitImage from "../assets/Test kit.png";

export const SummaryPage = ({ testKitCode,language }: { testKitCode: string,language:boolean }) => {
  const handleRegisterAnotherKit = () => {
    window.location.reload();
  };

  return (
 <div>
  {
    language?
    <div>
      <Typography variant="h6" gutterBottom>
      Vous avez enregistré votre kit avec succès
        <br />
        Numéro de kit {testKitCode}!
      </Typography>
      <Typography variant="subtitle1" gutterBottom component="div">
      Vous n’avez plus qu'à suivre les instructions contenues dans la boîte pour collecter et
nous retourner votre échantillon.
      </Typography>
      {/* <img src={testKitImage} alt="" style={{ display: "block", margin: "1rem auto 2rem auto" }} /> */}
      <Button variant="contained" sx={{ float: "right" }} onClick={handleRegisterAnotherKit}>
      Enregistrer un nouveau nit
      </Button>
    </div> :
   <div>
   <Typography variant="h6" gutterBottom>
     You have successfully registered your box
     <br />
     Kit No. {testKitCode}!
   </Typography>
   <Typography variant="subtitle1" gutterBottom component="div">
     Follow the instructions in the box on how to take a sample and returning the box.
   </Typography>
   {/* <img src={testKitImage} alt="" style={{ display: "block", margin: "1rem auto 2rem auto" }} /> */}
   <Button variant="contained" sx={{ float: "right" }} onClick={handleRegisterAnotherKit}>
     Register another kit
   </Button>
 </div>
}
    </div>
   
  );
};
